// extracted by mini-css-extract-plugin
module.exports = {"sectionRed":"sectionRed_sectionRed__2RCAY","heading1":"sectionRed_heading1__3WElx","span":"sectionRed_span__2Q9dL"};